// Core Module
// ONLY provide services from this module

import { NgModule } from '@angular/core';
import { environment } from '../../environments/environment';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

// @angular/fire/ imports
import { provideFirebaseApp, initializeApp, getApp } from '@angular/fire/app';
import { getFirestore, provideFirestore, connectFirestoreEmulator } from '@angular/fire/firestore';
import { provideAppCheck, initializeAppCheck, ReCaptchaV3Provider } from '@angular/fire/app-check';
import { getAuth, provideAuth, connectAuthEmulator } from '@angular/fire/auth';
import { getStorage, provideStorage, connectStorageEmulator } from '@angular/fire/storage';
import { getFunctions, provideFunctions, connectFunctionsEmulator } from '@angular/fire/functions';

// Custom services
import { UnivPrefsService } from './univ-prefs.service';
import { AuthService } from './auth.service';
import { AuthGuard } from './auth.guard';
import { QuestionsService } from './questions.service';
import { PublishingService } from './publishing.service';
import { InspectorService } from './inspector.service';
import { CalcConfigService } from './calc-config.service';
import { SelectorsService } from './selectors.service';
import { LoggingService } from './logging.service';

@NgModule({
    providers:
        [
            AuthService,
            UnivPrefsService,
            AuthGuard,
            QuestionsService,
            PublishingService,
            InspectorService,
            CalcConfigService,
            SelectorsService,
            LoggingService,
            provideHttpClient(withInterceptorsFromDi()),
            provideFirebaseApp(() => initializeApp(environment.firebaseEnv)),
            provideAppCheck(() => {
                return initializeAppCheck(getApp(), {
                    provider: new ReCaptchaV3Provider(environment.appCheck.siteKey),
                    isTokenAutoRefreshEnabled: true
                });
            }),
            provideAuth(() => {
                const auth = getAuth();
                if (environment.useEmulators) {
                    connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
                }
                return auth;
            }),
            provideFirestore(() => {
                const firestore = getFirestore();
                if (environment.useEmulators) {
                    connectFirestoreEmulator(firestore, 'localhost', 9001);
                }
                return firestore;
            }),
            provideFunctions(() => {
                const functions = getFunctions();
                if (environment.useEmulators) {
                    connectFunctionsEmulator(functions, 'localhost', 5001);
                }
                functions.customDomain = environment.functionsURL;
                return functions;
            }),
            provideStorage(() => {
                const storage = getStorage();
                if (environment.useEmulators) {
                    connectStorageEmulator(storage, 'localhost', 9199);
                }
                return storage;
            }),
        ]
})
export class CoreModule { }